module.exports = __webpack_public_path__ + "static/img/蒙版组 2@2x.3a35e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 2@2x.png
// module id = 0rbg
// module chunks = 1